import { Injectable }       from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class BaseService {
  
  currentHeight: number;
  isDisableResizeEvent: boolean = false;

  constructor() {

  }

  protected getApiUrl(apiname: string){
    return environment.apiEndPoint + "/playlist-api" + apiname;
  }

  protected getCloudApiUrl(apiname: string){
    return environment.cloudApiEndPoint + "/api" + apiname;
  }

  protected getPlayerUrl(apiname: string){
    return environment.playerEndPoint + "/api/" + apiname;
  }

  
  // protected setIdentityParamsForGet(params:HttpParams, auth:Auth){
  //   params = params.append('userId', auth.getUserId().toString());
  //   params = params.append('token', auth.getUserToken());
  //   return params;
  // }
  
  protected handleError(error: any): Promise<any> {
    console.log(error);
    return Promise.reject(error);
  }  

  // public enableResizeEvent(){
  //   this.isDisableResizeEvent = false;
  // }
  // public disableResizeEvent(){
  //   this.isDisableResizeEvent = true;
  // }

  public sendHeightToOuterFrame(videoHashPublic, height = null)
  {
    if(! videoHashPublic){
      return;
    }

    if(height){
      this.currentHeight = height;
    }
    else{
      if(! document.getElementById("app-root") || document.getElementById("app-root").offsetHeight < 90){
        return;
      }
      this.currentHeight = document.getElementById("app-root").offsetHeight;
    }

    let json = {
      id: "oneroll-" + videoHashPublic,
      height: this.currentHeight,
//        height: document.getElementById("app").clientHeight
    };
    console.log(json);
    window.parent.postMessage(JSON.stringify(json), "*");
  }

  // public sendMessageToOuterFrame(videoHashPublic)
  // {
  //   if(! videoHashPublic){
  //     return;
  //   }
  //   let json = {
  //     type: "MessageInit",
  //     id: "oneroll-" + videoHashPublic,
  //   };
  //   console.log(json);
  //   window.parent.postMessage(JSON.stringify(json), "*");
  // }
  
}

